<template>
    <section class="translation-value-item d-flex flex-row gap-2">
        <textarea v-model="internalValue.value" class="translation-value-item__input-text"></textarea>
        <pre></pre>
        <button @click="saveTranslation" class="
                            translation-value-item__bottom-btn
                            translation-value-item__bottom-btn--red
                        ">
            {{ $t('com.global.save') }}
        </button>
        <SmallLoader v-if="isLoading" />
    </section>
</template>
<script charset="utf-8">
import i18nService from '../../../../../services/i18n.service';
import SmallLoader from '../../../../BasicControls/SmallLoader.vue';
export default {
    name: "TranslationValueItem",
    components:{
        SmallLoader
    },
    computed:{
        getTranslationIndex(){
            if (!this.$store.state.i18nStore.internalTranslations) {
                return null;
            }

            if (!this.$store.state.i18nStore.internalTranslations[this.language.id]) {
                return null;
            }
            return this.$store.state.i18nStore.internalTranslations[this.language.id].findIndex(item => item.key === this.keyItem.key);
        }
    },
    data() {
        return {
            internalValue: {
                id: null,
                key: "",
                value: ""
            },
            isLoading: false
        }
    },
    props: {
        keyItem: {
            type: Object,
            required: true,
            default: () => ({
                id: null,
                key: "",
                name: "",
                description: ""
            })
        },
        value: {
            type: Object,
            required: true,
            default: () => ({
                id: null,
                key: "",
                value: ""
            })
        },
        language: {
            type: Object,
            required: true,
            default: () => ({
                id: null,
                code: "",
                culture: "",
                name: "",
                description: ""
            })
        }
    },
    watch: {
        value:{
            deep: true,
            immediate: true,
            handler: function(newVal){
                this.internalValue = newVal; // Synchronizujemy zmiany w prop
            }
        }
    },
    methods:{
        async saveTranslation(){
            try{
                this.isLoading = true;
                const request = {
                    id: this.value.id,
                    key: this.keyItem.key,
                    value: this.internalValue.value
                }

                if(request.id){
                    // update
                    const result = await i18nService.updateTranslationByLanguage(this.language.id, this.value.id, request);
                    if(result.status !== 200){
                        throw await Promise.reject(result)
                    }
                }
                else{
                    const result = await i18nService.addTranslationByLanguage(this.language.id, request);
                    if(result.status !== 200){
                        throw await Promise.reject(result)
                    }
                }
                await this.internalFetchTranslation();
            }
            catch(e){
                console.log(e);
            }
            finally{
                this.isLoading = false;
            }
        },
        async internalFetchTranslation(){
            const translation = await i18nService.getTranslationByLanguageId(this.language.id);
            if (translation.status !== 200) {
                throw await Promise.reject(translation);
            }
            this.$store.state.i18nStore.internalTranslations[this.language.id] = [];
            this.$store.state.i18nStore.internalTranslations[this.language.id] = translation.data;
        }
    }
}
</script>
<style lang="scss">
.translation-value-item {
    position: relative;
    &__input-text {
        margin-bottom: 10px;
        padding: 12.5px 16px;
        background: #ffffff;
        border: 1px solid #d1d6df;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
        border-radius: 4px;
        width: 100%;
        font-size: 16px;
        line-height: 144%;
        color: #00082c;
        min-width: 138px;

        &:focus {
            border: 1px solid #00082c;
        }

        &--small {
            min-width: 107px;
            margin-top: 7px;
        }
    }

    &__bottom-btn {
        padding: 5px 10px;
        border: 1px solid #bbc2ce;
        box-sizing: border-box;
        border-radius: 4px;
        background-color: transparent;
        font-weight: 500;
        font-size: 16px;
        height: 30px;
        line-height: 132%;
        color: #00082c;
        transition: all 0.2s ease-in-out;

        &:hover {
            background-color: #e8ebef;
        }

        &--red {
            background-color: #d80418;
            border: 0px;
            color: white;
            transition: all 0.2s ease-in-out;

            &:hover {
                background-color: #ad0313;
            }
        }
    }
}
</style>